import jsonLd from './functions/_jsonLd'
import display from './functions/display'

export default function JsonLdDisplay ({ buy, offer }) {
    return jsonLd(display(buy, offer))
}